(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["print-shop-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deco-print-shop-notice')) {
    customElements.define('deco-print-shop-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.context !== 'product') return;
        const connection = (this.connection || 0) + 1;
        this.connection = connection;
        customElements.whenDefined('variant-selection').then(() => {
          if (!this.isConnected || this.connection !== connection) return;
          const selection = this.closest('form')?.querySelector('[data-variant-selection]');
          if (!selection) {
            this.hidden = true;
            return;
          }
          this.selection = selection;
          this.revision = (this.revision || 0) + 1;
          this.onVariantChange = ({ detail }) => {
            const variant = detail?.variant;
            const current = selection.getAttribute('variant');
            if (variant ? String(variant.id) !== current : detail?.state !== current) return;
            this.revision += 1;
            this.updateNotice(variant);
          };
          selection.addEventListener('variant-change', this.onVariantChange);
          this.observer = new MutationObserver(() => {
            this.hidden = true;
            this.syncVariant();
          });
          this.observer.observe(selection, { attributes: true, attributeFilter: ['variant'] });
          this.syncVariant();
        });
      }

      disconnectedCallback() {
        this.connection = (this.connection || 0) + 1;
        this.revision = (this.revision || 0) + 1;
        this.selection?.removeEventListener('variant-change', this.onVariantChange);
        this.observer?.disconnect();
      }

      syncVariant() {
        if (typeof this.selection?.getVariant !== 'function') return;
        const revision = ++this.revision;
        this.selection.getVariant().then(variant => {
          if (this.isConnected && revision === this.revision) this.updateNotice(variant);
        }).catch(() => {
          if (this.isConnected && revision === this.revision) this.hidden = true;
        });
      }

      updateNotice(variant) {
        const id = variant ? String(variant.id) : '';
        this.hidden = !(
          variant?.requires_shipping === true
          && id === this.selection.getAttribute('variant')
          && id !== this.dataset.digitalVariantId
        );
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
